import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Check,
  Settings2,
  Recycle,
  Activity,
  FlaskConical,
  Wrench,
  PackageCheck,
  Waves,
  Filter,
  RotateCw,
  Wind,
  Droplets,
  Mail,
  ChevronDown,
} from "lucide-react";

const technologies = [
  {
    title: "Alquiler y Operación de Equipos",
    subtitle: "Equipos especializados para control de sólidos",
    icon: Settings2,
    description:
      "Disponemos de equipos de última tecnología para las diferentes etapas de separación de sólidos, operados por personal especializado para garantizar un desempeño eficiente y confiable.",
    items: [
      "Equipos para separación de sólidos",
      "Tecnología especializada para cada operación",
      "Operación por personal calificado",
      "Optimización del proceso de separación",
      "Mayor eficiencia y confiabilidad operativa",
    ],
  },

  {
    title: "Gestión de Residuos",
    subtitle: "Ingeniería para el manejo y disposición de residuos",
    icon: Recycle,
    description:
      "Diseñamos estrategias integrales para el manejo, reciclaje y disposición de residuos generados durante las operaciones, reduciendo el impacto ambiental.",
    items: [
      "Diseño de sistemas de gestión de residuos",
      "Estrategias de reciclaje y aprovechamiento",
      "Manejo responsable de residuos",
      "Optimización de procesos de disposición",
      "Reducción del impacto ambiental",
    ],
  },

  {
    title: "Optimización Integral de Fluidos",
    subtitle: "Monitoreo y mejora del desempeño de los fluidos",
    icon: Activity,
    description:
      "Utilizamos tecnologías especializadas para analizar y optimizar el comportamiento de los fluidos, mejorando su rendimiento durante la operación.",
    items: [
      "Análisis del comportamiento de los fluidos",
      "Monitoreo del desempeño en tiempo real",
      "Motion Analysis System",
      "Gforce – Vibrasense",
      "Optimización de parámetros operativos",
    ],
  },

  {
    title: "Consultoría en Fluidos de Perforación",
    subtitle: "Diseño y selección de fluidos para cada pozo",
    icon: FlaskConical,
    description:
      "Brindamos asesoramiento especializado para seleccionar y diseñar sistemas de fluidos adaptados a las condiciones específicas de cada pozo y operación.",
    items: [
      "Selección de sistemas de fluidos",
      "Diseño de soluciones para cada pozo",
      "Evaluación de condiciones operativas",
      "Optimización del desempeño del fluido",
      "Soporte técnico especializado",
    ],
  },

  {
    title: "Revisión y Optimización de Equipos",
    subtitle: "Auditoría y mejora del rendimiento operativo",
    icon: Wrench,
    description:
      "Evaluamos y optimizamos equipos de control de sólidos existentes para mejorar su rendimiento, eficiencia y confiabilidad, prolongando su vida útil.",
    items: [
      "Auditoría de equipos existentes",
      "Evaluación del desempeño operativo",
      "Identificación de oportunidades de mejora",
      "Optimización de procesos y equipos",
      "Prolongación de la vida útil",
    ],
  },

  {
    title: "Venta Directa de Productos",
    subtitle: "Productos químicos y aditivos especializados",
    icon: PackageCheck,
    description:
      "Suministramos productos químicos y aditivos de alta calidad para el tratamiento de fluidos y procesos de deshidratación, según las necesidades de cada operación.",
    items: [
      "Productos químicos especializados",
      "Aditivos para tratamiento de fluidos",
      "Productos para procesos de deshidratación",
      "Soluciones adaptadas a cada operación",
      "Suministro de productos de alta calidad",
    ],
  },
];

const solidControlEquipment = [
  {
    number: "1",
    title: "Zarandas Vibratorias",
    subtitle: "Shale Shakers",
    icon: Waves,
    description:
      "Remoción de sólidos de gran tamaño para mantener las propiedades y el desempeño del fluido.",
  },
  {
    number: "2",
    title: "Desarenadores y Deslimadores",
    subtitle: "Hidrociclones",
    icon: Filter,
    description:
      "Separación de partículas de arena y limo para mejorar la eficiencia del sistema de control de sólidos.",
  },
  {
    number: "3",
    title: "Centrífugas Decantadoras",
    subtitle: "Separación de sólidos finos",
    icon: RotateCw,
    description:
      "Separación de sólidos finos y recuperación de fluidos pesados para optimizar el proceso.",
  },
  {
    number: "4",
    title: "Sistemas de Desgasificación",
    subtitle: "Control de gas entrampado",
    icon: Wind,
    description:
      "Eliminación de gas entrampado en el fluido para mantener condiciones operativas seguras y estables.",
  },
  {
    number: "5",
    title: "Unidades de Dewatering",
    subtitle: "Tratamiento de residuos",
    icon: Droplets,
    description:
      "Tratamiento de lodos de desecho y reducción de su volumen para facilitar su manejo y disposición.",
  },
];

const heroImage = "/Images/services/oil-gas/solid-control/DW.webp";
const SolidControl = () => {
  const [openTechnology, setOpenTechnology] = useState(null);
  return (
    <>
      {/* HERO */}
      <section className="overflow-hidden">
        <div
          className="
      relative
      h-[520px]
      sm:h-[500px]
      md:h-[560px]
      lg:h-[580px]
      xl:h-[600px]
    "
        >
          <img
            src={heroImage}
            alt="Control de Sólidos"
            className="
        absolute
        inset-0
        w-full
        h-full
        object-cover
        object-[center_10%]
        sm:object-[center_10%]
        md:object-[center_15%]
        lg:object-[center_15%]
      "
          />

          <div className="absolute inset-0 bg-black/40" />

          <div
            className="
        absolute
        inset-0
        bg-gradient-to-r
        from-black/65
        via-black/35
        to-transparent
      "
          />

          <div
            className="
        absolute
        inset-0
        flex
        items-center
      "
          >
            <div
              className="
          w-full
          max-w-7xl
          mx-auto
          px-4
          sm:px-6
          lg:px-8
        "
            >
              <div
                className="
            max-w-3xl
            pt-10
            sm:pt-12
            md:pt-14
          "
              >
                <span
                  className="
              inline-flex
              items-center
              px-3
              py-1.5
              sm:px-4
              sm:py-2
              rounded-full
              bg-[#ee7d32]/20
              text-[#ee7d32]
              text-xs
              sm:text-sm
              font-semibold
              uppercase
              tracking-wider
            "
                >
                  Servicios
                </span>

                <h1
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-4xl
              sm:text-5xl
              md:text-6xl
              lg:text-7xl
              font-bold
              text-white
              leading-[0.95]
              tracking-tight
            "
                >
                  Control de
                  <br />
                  <span className="text-[#ee7d32]">Sólidos</span>
                </h1>

                <p
                  className="
              mt-4
              sm:mt-5
              md:mt-6
              text-base
              sm:text-lg
              md:text-xl
              text-white/90
              leading-7
              md:leading-8
              max-w-2xl
            "
                >
                  Ingeniería integral para optimizar la eficiencia, seguridad y
                  rentabilidad de las operaciones Oil & Gas.
                </p>

                <p
                  className="
              mt-3
              sm:mt-4
              md:mt-5
              text-sm
              sm:text-base
              text-white/80
              leading-6
              sm:leading-7
              max-w-2xl
            "
                >
                  En Sierra Alta integramos equipos de última tecnología,
                  optimización de fluidos, gestión de residuos y soporte
                  especializado para maximizar el desempeño de las operaciones.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICIOS DE CONTROL DE SÓLIDOS */}
      <section className="relative py-20 md:py-24 bg-[#f3f3f3] overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1]">
              Soluciones Integrales{" "}
              <span className="text-[#ee7d32]">en Control de Sólidos</span>
            </h2>

            <p className="mt-6 text-base sm:text-lg text-[#555] leading-8 max-w-2xl">
              Integramos equipos especializados, ingeniería y soporte técnico
              para optimizar la separación de sólidos, mejorar el desempeño de
              los fluidos y garantizar operaciones más eficientes y confiables.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-7 mt-16">
            {technologies.map((item, index) => {
              const Icon = item.icon;
              const isOpen = openTechnology === index;

              return (
                <div
                  key={index}
                  className={`
          group
          relative
          flex
          flex-col
          h-full
          bg-white
          rounded-3xl
          px-7
          pt-14
          pb-7
          border
          border-gray-100
          transition-all
          duration-500
          ${
            isOpen
              ? "shadow-[0_25px_70px_rgba(238,125,50,0.12)]"
              : "shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:-translate-y-2 hover:shadow-[0_30px_80px_rgba(238,125,50,0.14)]"
          }
        `}
                >
                  <div
                    className="
            absolute
            -top-9
            left-7
            w-[72px]
            h-[72px]
            rounded-full
            bg-[#ee7d32]
            flex
            items-center
            justify-center
            shadow-[0_12px_30px_rgba(238,125,50,0.25)]
            transition-all
            duration-500
            group-hover:scale-110
            group-hover:shadow-[0_16px_35px_rgba(238,125,50,0.35)]
          "
                  >
                    <Icon className="w-8 h-8" stroke="white" strokeWidth={2} />
                  </div>

                  <div className="flex flex-col flex-1">
                    <h3
                      className="
              text-xl
              sm:text-[22px]
              font-extrabold
              text-[#111]
              leading-tight
              pr-10
            "
                    >
                      {item.title}
                    </h3>

                    <p
                      className="
              mt-2
              text-sm
              font-semibold
              text-[#ee7d32]
            "
                    >
                      {item.subtitle}
                    </p>

                    <p
                      className="
              mt-5
              text-sm
              text-gray-600
              leading-7
            "
                    >
                      {item.description}
                    </p>

                    <div className="mt-auto pt-6 flex justify-end">
                      <button
                        type="button"
                        onClick={() => setOpenTechnology(isOpen ? null : index)}
                        className="
                group/details
                inline-flex
                items-center
                gap-2
                text-sm
                font-bold
                transition-all
                duration-300
              "
                      >
                        <span
                          className="
                  text-[#666666]
                  group-hover/details:text-[#ee7d32]
                  transition-colors
                  duration-300
                "
                        >
                          {isOpen ? "Ocultar detalles" : "Conocer más"}
                        </span>

                        <ChevronDown
                          className={`
                  w-4
                  h-4
                  stroke-[#666666]
                  group-hover/details:stroke-[#ee7d32]
                  transition-all
                  duration-300
                  ${isOpen ? "rotate-180 stroke-[#ee7d32]" : ""}
                `}
                          strokeWidth={2}
                        />
                      </button>
                    </div>
                  </div>

                  <div
                    className={`
            overflow-hidden
            transition-all
            duration-500
            ease-in-out
            ${
              isOpen
                ? "max-h-[500px] opacity-100 mt-6"
                : "max-h-0 opacity-0 mt-0"
            }
          `}
                  >
                    <div className="border-t border-gray-100 pt-6">
                      <p
                        className="
                text-xs
                font-bold
                uppercase
                tracking-[0.12em]
                text-gray-400
                mb-4
              "
                      >
                        Alcance del servicio
                      </p>

                      <div className="space-y-3">
                        {item.items.map((x, i) => (
                          <div key={i} className="flex items-start gap-3">
                            <div
                              className="
                      mt-1
                      w-5
                      h-5
                      rounded-full
                      bg-[#ee7d32]/10
                      flex
                      items-center
                      justify-center
                      shrink-0
                    "
                            >
                              <Check
                                className="w-3 h-3"
                                stroke="#ee7d32"
                                strokeWidth={3}
                              />
                            </div>

                            <span
                              className="
                      text-sm
                      text-gray-600
                      leading-6
                    "
                            >
                              {x}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* EQUIPOS Y TECNOLOGÍAS */}
      <section className="relative py-20 md:py-24 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1]">
              Equipos y <span className="text-[#ee7d32]">Tecnologías</span>
            </h2>

            <p className="mt-6 text-base sm:text-lg text-[#555] leading-8 max-w-2xl">
              Tecnología especializada para cada etapa del control de sólidos,
              desde la separación primaria hasta el tratamiento y gestión de
              residuos generados durante la operación.
            </p>
          </div>

          <div className="mt-20">
            {solidControlEquipment.map((item, index) => {
              const Icon = item.icon;
              const isLast = index === solidControlEquipment.length - 1;

              return (
                <div
                  key={index}
                  className="
              group
              relative
              grid
              grid-cols-1
              md:grid-cols-[90px_1fr]
              gap-6
              md:gap-10
            "
                >
                  {!isLast && (
                    <div
                      className="
                  absolute
                  left-[44px]
                  top-[90px]
                  bottom-0
                  w-px
                  bg-gradient-to-b
                  from-[#ee7d32]
                  via-[#ee7d32]/30
                  to-transparent
                  hidden
                  md:block
                "
                    />
                  )}

                  <div className="relative z-10">
                    <div
                      className="
                  w-[88px]
                  h-[88px]
                  rounded-full
                  bg-[#ee7d32]
                  border
                  border-[#ee7d32]/20
                  flex
                  items-center
                  justify-center
                  shadow-[0_10px_30px_rgba(238,125,50,0.10)]
                  transition-all
                  duration-500
                  group-hover:scale-110
                  group-hover:border-[#ee7d32]
                  group-hover:shadow-[0_15px_35px_rgba(238,125,50,0.20)]
                "
                    >
                      <Icon
                        className="
                    w-9
                    h-9
                    transition-transform
                    duration-500
                    group-hover:scale-110
                  "
                        stroke="white"
                        strokeWidth={1.7}
                      />
                    </div>
                  </div>

                  <div
                    className={`
                relative
                pb-14
                md:pb-16
                ${
                  !isLast
                    ? "border-b border-gray-200 mb-12 md:border-0 md:mb-0"
                    : ""
                }
              `}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                      <div>
                        <span
                          className="
                      text-xs
                      font-bold
                      uppercase
                      tracking-[0.18em]
                      text-[#ee7d32]
                    "
                        >
                          Equipo {item.number}
                        </span>

                        <h3
                          className="
                      mt-2
                      text-2xl
                      sm:text-3xl
                      font-bold
                      text-[#111]
                      leading-tight
                      transition-colors
                      duration-300
                      group-hover:text-[#ee7d32]
                    "
                        >
                          {item.title}
                        </h3>

                        <p className="mt-2 text-sm font-semibold text-gray-500">
                          {item.subtitle}
                        </p>
                      </div>
                    </div>

                    {/* DESCRIPCIÓN */}
                    <p
                      className="
                  mt-5
                  max-w-3xl
                  text-sm
                  md:text-base
                  text-gray-600
                  leading-7
                "
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* BENEFICIOS OPERATIVOS */}
      <section className="relative py-16 md:py-24 bg-[#f3f3f3] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="relative">
              <div
                className="
            overflow-hidden
            rounded-[38px]
            rounded-tr-[110px]
            rounded-bl-[110px]
            shadow-[0_20px_60px_rgba(0,0,0,0.10)]
          "
              >
                <img
                  src="/Images/services/oil-gas/solid-control/solid-control.webp"
                  alt="Beneficios operativos del control de sólidos"
                  className="
              w-full
              h-[340px]
              sm:h-[430px]
              md:h-[520px]
              object-cover
              transition-transform
              duration-700
              hover:scale-105
            "
                />
              </div>

              <div
                className="
            absolute
            -bottom-5
            -right-5
            w-24
            h-24
            rounded-full
            bg-[#ee7d32]/10
            -z-0
          "
              />

              <div
                className="
            absolute
            bottom-6
            left-6
            bg-white/95
            backdrop-blur-sm
            rounded-2xl
            px-5
            py-4
            shadow-[0_12px_35px_rgba(0,0,0,0.10)]
          "
              >
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#ee7d32]">
                  Control de sólidos
                </p>

                <p className="mt-1 text-sm font-semibold text-[#111]">
                  Eficiencia · Seguridad · Rentabilidad
                </p>
              </div>
            </div>

            <div>
              <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#111] leading-tight">
                Beneficios <span className="text-[#ee7d32]">Operativos</span>
              </h2>

              <p className="mt-6 text-[#555] text-sm sm:text-base md:text-lg leading-7">
                Un sistema eficiente de control de sólidos permite optimizar el
                desempeño de la operación, reducir costos y mejorar la gestión
                ambiental.
              </p>

              <div className="mt-8 space-y-4">
                <div className="flex items-start gap-4">
                  <div
                    className="
                w-11
                h-11
                rounded-2xl
                bg-[#fff3eb]
                flex
                items-center
                justify-center
                shrink-0
                shadow-[0_8px_25px_rgba(238,125,50,0.12)]
              "
                  >
                    <span className="text-sm font-bold text-[#ee7d32]">01</span>
                  </div>

                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-[#111]">
                      Maximiza la Tasa de Penetración (ROP)
                    </h3>

                    <p className="mt-1 text-sm text-gray-600 leading-6">
                      Mantiene las propiedades del fluido dentro de los rangos
                      óptimos para favorecer una perforación más eficiente.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="
                w-11
                h-11
                rounded-2xl
                bg-[#fff3eb]
                flex
                items-center
                justify-center
                shrink-0
                shadow-[0_8px_25px_rgba(238,125,50,0.12)]
              "
                  >
                    <span className="text-sm font-bold text-[#ee7d32]">02</span>
                  </div>

                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-[#111]">
                      Reduce el Tiempo No Productivo (NPT)
                    </h3>

                    <p className="mt-1 text-sm text-gray-600 leading-6">
                      Reduce el desgaste de los equipos y minimiza paradas no
                      programadas durante la operación.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="
                w-11
                h-11
                rounded-2xl
                bg-[#fff3eb]
                flex
                items-center
                justify-center
                shrink-0
                shadow-[0_8px_25px_rgba(238,125,50,0.12)]
              "
                  >
                    <span className="text-sm font-bold text-[#ee7d32]">03</span>
                  </div>

                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-[#111]">
                      Mayor vida útil de los fluidos
                    </h3>

                    <p className="mt-1 text-sm text-gray-600 leading-6">
                      Disminuye la necesidad de reemplazar o reformular fluidos,
                      reduciendo costos y generación de residuos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="
                w-11
                h-11
                rounded-2xl
                bg-[#fff3eb]
                flex
                items-center
                justify-center
                shrink-0
                shadow-[0_8px_25px_rgba(238,125,50,0.12)]
              "
                  >
                    <span className="text-sm font-bold text-[#ee7d32]">04</span>
                  </div>

                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-[#111]">
                      Gestión ambiental responsable
                    </h3>

                    <p className="mt-1 text-sm text-gray-600 leading-6">
                      Facilita el manejo adecuado de residuos y contribuye al
                      cumplimiento de los requisitos ambientales aplicables.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="
            mt-8
            border-l-4
            border-[#ee7d32]
            bg-white
            rounded-r-2xl
            px-5
            py-4
            shadow-[0_8px_30px_rgba(0,0,0,0.05)]
          "
              >
                <p className="text-sm sm:text-base font-semibold text-[#222] leading-6">
                  Una gestión eficiente de sólidos se traduce en operaciones más
                  productivas, confiables y sostenibles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA CONTROL DE SÓLIDOS */}
      <section className="relative py-10 md:py-12 bg-white overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="
        group
        relative
        overflow-hidden
        rounded-[30px]
        border
        border-[#ececec]
        bg-white
        shadow-[0_12px_40px_rgba(0,0,0,0.05)]
        transition-all
        duration-300
        hover:shadow-[0_20px_60px_rgba(0,0,0,0.10)]
      "
          >
            <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-[#ee7d32] via-[#ee7d32]/50 to-transparent" />

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 px-6 py-8 md:px-10 md:py-9">
              <div className="flex flex-col sm:flex-row items-start gap-5 max-w-3xl">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-[#ee7d32]/20 blur-xl rounded-2xl" />

                  <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center">
                    <Mail
                      size={40}
                      className="stroke-[#ee7d32]"
                      strokeWidth={1.8}
                    />
                  </div>
                </div>

                <div>
                  <span
                    className="
                inline-flex
                items-center
                rounded-full
                bg-[#ee7d32]/10
                border
                border-[#ee7d32]/20
                px-3
                py-1
                text-[11px]
                md:text-[12px]
                font-semibold
                uppercase
                tracking-widest
                text-[#ee7d32]
              "
                  >
                    Control de sólidos
                  </span>

                  <h3 className="mt-3 text-2xl sm:text-3xl font-bold text-[#111] leading-tight">
                    ¿Necesitas una solución efectiva para el Control de Sólidos?
                  </h3>

                  <p className="mt-3 text-sm md:text-base leading-7 text-[#6b7280] max-w-2xl">
                    Optimiza el desempeño de tu operación con equipos,
                    tecnología y soluciones especializadas para el control
                    eficiente de sólidos.
                  </p>
                </div>
              </div>

              <div className="flex w-full lg:w-auto">
                <Link
                  to="/contact-us?division=oilgas&service=Control de sólidos"
                  className="
              group/btn
              inline-flex
              w-full
              sm:w-auto
              items-center
              justify-center
              gap-3
              rounded-lg
              bg-[#ee7d32]
              px-6
              py-3.5
              md:px-7
              md:py-4
              text-sm
              font-semibold
              text-white
              transition-all
              duration-300
              hover:bg-[#e56f20]
              hover:shadow-lg
              hover:shadow-[#ee7d32]/20
            "
                >
                  Contáctanos
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover/btn:translate-x-1"
                    color="white"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SolidControl;
